import { toast } from 'sonner';
import { useMutation } from '@apollo/client/react';

import { useCancellationPlan } from 'src/context/billing';
import { ClientError, getApiError } from 'src/utils/errors';
import { RequestExclusiveOfferDocument } from 'src/graphql/actions/billing/requestExclusiveOffer.mutation';
import { Button } from '@/components/ui/button';

const GetOfferButton = () => {
  const {
    ui: { setStep },
  } = useCancellationPlan();
  const [requestExclusiveOffer, { loading }] = useMutation(RequestExclusiveOfferDocument);

  const onGetOffer = async () => {
    try {
      const { data } = await requestExclusiveOffer();

      if (data?.requestExclusiveOffer?.success) setStep('discount-request');
      else {
        throw new ClientError(data?.requestExclusiveOffer?.errors?.[0]);
      }
    } catch (error) {
      getApiError(error, toast.error);
    }
  };

  return (
    <Button variant="secondary" isLoading={loading} onClick={onGetOffer}>
      Get offer
    </Button>
  );
};

export default GetOfferButton;
